<div class="affair-container">
  @if (affairLoading) {
    <div class="loading-container">
      <p-progressSpinner
        styleClass="w-10 h-10 animate-pulse"
      ></p-progressSpinner>
      <span class="loading-text">Chargement des informations...</span>
    </div>
  } @else {
    @let affair = affair$ | async;
    @let products = products$ | async;
    @let mails = mails$ | async;
    @let interventions = interventions$ | async;
    @if (affair !== null && affair !== undefined) {
      <div class="customer-header">
        <div class="flex items-center gap-2">
          <i class="pi pi-user-edit text-xl text-blue-400"></i>
          <p class="text-xl font-medium">
            {{ affair.finalCustomerLastname }}
            {{ affair.finalCustomerFirstname }}
          </p>
        </div>
        @if (
          affair.finalCustomerLastnameSecondary ||
          affair.finalCustomerFirstnameSecondary
        ) {
          <p class="text-lg ml-6 text-gray-300">
            {{ affair.finalCustomerLastnameSecondary }}
            {{ affair.finalCustomerFirstnameSecondary }}
          </p>
        }
      </div>

      <p-card styleClass="main-card">
        <div class="content-wrapper">
          <!-- Sidebar Navigation -->
          <div class="sidebar-nav">
            @for (tab of tabs; track tab.id) {
              <p-button
                [label]="tab.label"
                [icon]="tab.icon"
                [severity]="isActiveTab(tab.id) ? 'success' : 'secondary'"
                (click)="setActiveTab(tab.id)"
                styleClass="tab-button"
                [outlined]="!isActiveTab(tab.id)"
                [rounded]="true"
              ></p-button>
            }
          </div>

          <!-- Tab Content -->
          <div class="tab-content">
            @switch (activeTab) {
              @case (0) {
                <app-affair-informations
                  [affair]="affair"
                ></app-affair-informations>
              }
              @case (1) {
                <app-affair-products
                  [products]="products"
                  [productsLoading]="productsLoading"
                ></app-affair-products>
              }
              @case (2) {
                <app-affair-interventions
                  [affair]="affair"
                  [interventions]="interventions"
                ></app-affair-interventions>
              }
              @case (3) {
                <app-affair-mails
                  [mails]="mails"
                  [mailsLoading]="mailsLoading"
                ></app-affair-mails>
              }
            }
          </div>
        </div>
      </p-card>
    } @else if (dataLoadError) {
      <div class="error-container">
        <i class="pi pi-exclamation-circle error-icon animate-pulse"></i>
        <p class="error-text">
          Impossible de charger les informations de l'affaire
        </p>
        <p-button
          label="Réessayer"
          icon="pi pi-refresh"
          (click)="initializeData()"
          severity="danger"
          [rounded]="true"
        ></p-button>
      </div>
    } @else {
      <div class="loading-container">
        <p-progressSpinner
          styleClass="w-10 h-10 animate-pulse"
        ></p-progressSpinner>
        <span class="loading-text">Initialisation des données...</span>
      </div>
    }
  }
</div>
